var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPointsIconProfile = function SvgPointsIconProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.703 2.548v-1.25a.297.297 0 1 1 .594 0v1.25a.297.297 0 1 1-.594 0ZM5.463 2.78a.296.296 0 0 0 .42-.007.297.297 0 0 0-.008-.42l-.897-.867a.297.297 0 1 0-.413.427l.898.867ZM8.33 2.864a.296.296 0 0 0 .207-.084l.898-.867a.297.297 0 0 0-.413-.427l-.897.867a.297.297 0 0 0 .206.51Z",
    stroke: "#212121",
    strokeWidth: 0.1,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.93 6.129-1.889 2.24a.296.296 0 1 1-.454-.383l1.477-1.751H9.786l-1.884 4.937 1.89-2.242a.297.297 0 1 1 .454.383l-3.019 3.581a.297.297 0 0 1-.454 0L1.07 6.13a.297.297 0 0 1-.005-.377l.717-.9a.297.297 0 1 1 .465.37l-.334.418h2.332l1.01-1.793H3.34l-.325.41a.297.297 0 1 1-.465-.371l.415-.521a.297.297 0 0 1 .232-.112h7.604c.09 0 .176.041.232.112l1.901 2.387a.297.297 0 0 1-.005.377Z",
    stroke: "#212121",
    strokeWidth: 0.2,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEBD1",
    d: "M10.659 3.847H8.746L9.755 5.64h2.332zM4.927 5.64h4.146L8.064 3.847H5.936zM1.936 6.235l4.162 4.937-1.884-4.937zM9.15 6.235h-4.3L7 11.87z"
  }))));
};
export default SvgPointsIconProfile;